<span class="result-odds">{{ option.nativePrice | msNativePriceFormatter }}</span>
<vn-icon class="result-locked tree-item-locked" size="14" [name]="isEpcotEnabled ? 'theme-locked' : 'theme-locked-i'" />
<span class="result-name">
    <ms-inline-tooltip [applyClass]="'option-name-tooltip-msg'">
        <span #tooltipContent class="title">{{ name }}</span>
    </ms-inline-tooltip>
</span>
